export default __webpack_public_path__ + "static/media/640_dummy2016-coach02-de.821ec96b.png";